import React, { useRef, useState } from 'react';
import { storage } from '../../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const MediaUploader = ({ onUpload }) => {
  const fileInputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(resolve, 'image/webp', 0.8);
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  };

  const handleUpload = async () => {
    const file = fileInputRef.current.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const webpBlob = await convertToWebP(file);
      const fileName = `${Date.now()}_${file.name.replace(/\.[^/.]+$/, '')}.webp`;
      const storageRef = ref(storage, `images/${fileName}`);
      await uploadBytes(storageRef, webpBlob);
      const url = await getDownloadURL(storageRef);
      onUpload(url);
    } catch (error) {
      console.error('Upload failed:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="mb-3">
      <label className="form-label">Upload Image</label>
      <input type="file" ref={fileInputRef} accept="image/*" className="form-control" />
      <button onClick={handleUpload} disabled={uploading} className="btn btn-primary mt-2">
        {uploading ? 'Uploading...' : 'Upload'}
      </button>
    </div>
  );
};

export default MediaUploader;